/* eslint-disable @typescript-eslint/naming-convention */
export class PlantDropdownDtoPascal {
  public PlantId: number;
  public Name: string;
  public VpCompanyId?: number;
  public ParentFacilityID: number | null;
  public VpParentFacilityKeyId: number | null;
}
